import { __awaiter } from "tslib";
import { systemRights, } from "@tedivo/tvd-api-models";
import { TedivoForm, translateTedivoForm, } from "@tedivo/tedivo-form";
import { ListComponentWithActions } from "../../common/ListComponentWithActions";
import Services from "../../../app/services";
import { createTableUserStorageInstance } from "../../../app/preferences/createTableUserStorageInstance";
import { getTranslation } from "../../../app/i18/i18tn";
import goSquared from "../../../app/tracking/goSquared";
import securityModule from "../../../app/security/SecurityModule";
import { setAppTitle } from "../../../app/setAppTitle";
import { z } from "zod";
export class TVDAdminDomainFedsComponent extends ListComponentWithActions {
    constructor() {
        super();
        this.allOrgsList = [];
        this.domainsConsumers = {};
        this.h1Label = "general:organizations.federations.title";
        this.goSquaredLabel = "Admin/DomainFederations";
        this.topLabel = "general:adminArea";
        //this.createLabel = "general:parentOrganizations.adminCreate";
        this.editLabel = "general:organizations.federations.edit";
        this.deleteLabel = "general:organizations.federations .delete";
        this.serviceListCall = Services.domainFederations.getAll;
        this.serviceDeleteCall = Services.domainFederations.delete;
        this.serviceEditCall = Services.domainFederations.update;
        this.systemRightToEdit = systemRights.ORG.AppAdminDomains;
        this.preDisplayFnCall = () => __awaiter(this, void 0, void 0, function* () {
            const res = yield Services.organizations.adminGetAllOrganizations();
            if (res.data) {
                this.allOrgsList = res.data.sort((a, b) => a.name.localeCompare(b.name));
                this.allOrgsList.forEach((org) => {
                    const domains = org.domains || [];
                    domains.forEach((domain) => {
                        if (!this.domainsConsumers[domain]) {
                            this.domainsConsumers[domain] = [];
                        }
                        this.domainsConsumers[domain].push(org.organizationId);
                    });
                });
            }
        });
        const userOptionsStorage = createTableUserStorageInstance("adminFederationstList");
        this.tableConfig = (data) => createParentOrgsTableConfig(data, this.systemRightToEdit, userOptionsStorage, this.allOrgsList, this.domainsConsumers, this.openEditModal, this.openDeleteModal);
        this.createEditForm = (submitButton, prevData) => createParentOrgEdit(submitButton, prevData, this.allOrgsList, this.domainsConsumers);
        setAppTitle(getTranslation("general:parentOrganizations.title"));
        goSquared.trackPage("TEDIVO Admin Pages - Parent Organizations");
    }
}
TVDAdminDomainFedsComponent.observedAttributes = [];
customElements.define("tvd-admin-federations-component", TVDAdminDomainFedsComponent);
function createParentOrgsTableConfig(parentOrganizations, systemRightToEdit, userOptionsStorage, allOrgsList, domainsConsumers, onEditSaveFn, onDeleteFn) {
    const tableConfig = {
        className: "tvd-table tvd-table-smart-table",
        data: parentOrganizations,
        defaultSortBy: "name",
        fields: [
            {
                name: "domain",
                label: getTranslation("general:domains.domain"),
                type: "string",
                fixedWidth: "240px",
            },
            {
                name: "domainOwnershipVerified",
                type: "string",
                valueFunction: (dta) => dta.domainOwnershipVerified
                    ? getTranslation("general:common.yes")
                    : getTranslation("general:common.no"),
                className: (dta) => `centered ${(dta === null || dta === void 0 ? void 0 : dta.domainOwnershipVerified) ? "text-success" : ""}`,
                fixedWidth: "160px",
                label: getTranslation("general:organizations.federations.domainOwnershipVerified"),
            },
            {
                name: "enabled",
                type: "string",
                className: "centered",
                fixedWidth: "200px",
                valueFunction: (dta) => dta.enabled
                    ? getTranslation("general:common.yes")
                    : getTranslation("general:common.no"),
                label: getTranslation("general:organizations.federations.enabled"),
            },
            {
                name: "provider",
                type: "string",
                className: "centered",
                fixedWidth: "140px",
                valueFunction: (dta) => dta.domainOwnershipVerified && dta.enabled
                    ? dta.provider || "-"
                    : "-",
                label: getTranslation("general:organizations.federations.provider"),
            },
            {
                name: "id",
                type: "string",
                valueFunction: (dta) => returnListOfOrganizationsUsingDomain(dta.domain, dta.orgIdOwner).join(", ") || "-",
                className: "underlned-is-highlight",
                label: getTranslation("general:organizations.federations.orgIdUsers"),
            },
        ],
        settings: {
            sortEnabled: true,
            sortVisible: true,
            userOptionsStorage,
            filters: {
                textFieldEnabled: true,
                textFieldFilterFields: ["name"],
                initialTextFieldFilter: userOptionsStorage.retrieveFilterText(),
            },
            labelSortBy: getTranslation("general:common.sortBy"),
            labelSearch: getTranslation("general:common.filterBy"),
        },
        pkFunction: (dta) => dta.domain,
    };
    if (systemRightToEdit &&
        securityModule.userHasPermission(systemRightToEdit)) {
        tableConfig.fields.push({
            name: "domain",
            label: getTranslation("general:common.edit"),
            type: "icon",
            icon: "pencil",
            fixedWidth: "80px",
            notSortable: true,
            onClick: (dta) => {
                onEditSaveFn(dta.domain, dta);
            },
        });
        tableConfig.fields.push({
            name: "domain",
            label: getTranslation("general:common.delete"),
            type: "icon",
            icon: "trash",
            iconVariant: "danger",
            fixedWidth: "80px",
            notSortable: true,
            onClick: (dta) => {
                onDeleteFn === null || onDeleteFn === void 0 ? void 0 : onDeleteFn(dta.domain, dta, "domain");
            },
        });
    }
    return tableConfig;
    function returnListOfOrganizationsUsingDomain(domain, orgIdOwner) {
        var _a;
        const orgNames = (_a = domainsConsumers[domain]) === null || _a === void 0 ? void 0 : _a.map((orgId) => {
            const org = allOrgsList.find((org) => org.organizationId === orgId);
            return org
                ? org.organizationId === orgIdOwner
                    ? `<u>${org.name}</u>`
                    : org.name
                : "";
        });
        return (orgNames === null || orgNames === void 0 ? void 0 : orgNames.sort()) || [];
    }
}
function createParentOrgEdit(submitButton, prevData, allOrgsList = [], domainsConsumers = {}) {
    var _a, _b;
    const holder = document.createElement("div");
    if (!prevData) {
        throw new Error("prevData is undefined");
    }
    const formFields = [
        {
            name: "domain",
            label: "general:domains.domain",
            type: "textBox",
            disabled: true,
            initialValue: (prevData === null || prevData === void 0 ? void 0 : prevData.domain) || "",
        },
        {
            name: "orgIdOwner",
            label: "general:organizations.federations.orgIdOwner",
            type: "select",
            options: allOrgsList
                .filter((org) => domainsConsumers[prevData.domain].includes(org.organizationId))
                .map((org) => ({
                label: org.name,
                value: org.organizationId,
            })),
            initialValue: (_a = prevData === null || prevData === void 0 ? void 0 : prevData.orgIdOwner) !== null && _a !== void 0 ? _a : "",
        },
        {
            name: "enabled",
            label: "general:organizations.federations.enabled",
            type: "checkbox",
            disabled: true,
            initialValue: (_b = prevData === null || prevData === void 0 ? void 0 : prevData.enabled) !== null && _b !== void 0 ? _b : true,
            helpText: "general:organizations.federations.enabledInfo",
        },
    ];
    const formValidator = z.object({
        orgIdOwner: z.string().min(1),
    });
    const tedivoForm = new TedivoForm({
        fields: formFields,
        onSubmit: () => undefined,
        formValidator: formValidator,
        submitButton: submitButton,
        formProps: { autoFocusOnFirstInput: true },
        hiddenData: prevData,
        logValidationResult: true,
    });
    translateTedivoForm({
        tedivoForm,
        getTranslation,
    });
    holder.appendChild(tedivoForm.form);
    return {
        node: holder,
        tedivoForm,
        submitFunction: submitPassedToEditDrawer,
    };
    function submitPassedToEditDrawer() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!prevData) {
                throw new Error("prevData is undefined");
            }
            const validResult = tedivoForm.doSubmitForm();
            const values = tedivoForm.getValues();
            const data = Object.assign(Object.assign({}, prevData), { orgIdOwner: values.orgIdOwner });
            if (values.orgIdOwner === prevData.orgIdOwner) {
                return true;
            }
            if (validResult.success) {
                yield Services.domainFederations.update(data);
                return true;
            }
            else {
                return false;
            }
        });
    }
}
